import React, { useState, useRef } from 'react'
import { Button, Card } from 'antd'
import { useSelector } from 'react-redux'
import { formatMessageNew, downLoadFileBlob, formatStartTime, formatEndTime } from '@/utils/common'
import { messageModal, modalError } from '@/utils/modalUtils'
import { hasPermission } from '@/annotations/nike-react'
import {
  uidSendFailurePage,
  uidSendFailureDownload,
  uidSendFailureResend
} from '@/services/Email/NFCUIDSentFailureReport'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '../../../components/searchbar/SearchBar'
import ActionBar from '@/components/table/ActionBar'
import dayjs from 'dayjs'

const dateFormat = 'YYYY-MM-DD'
const startMonth = dayjs()
  .subtract(1, 'month')
  .add(1, 'day')
  .startOf('day')
const endMonth = dayjs().endOf('day')
const menu_email_nfc_uid_send_failure_report = 'menu_email_nfc_uid_send_failure_report'

const NFCUIDSentFailureReport = () => {
  const languageState = useSelector(state => state.commonStore.language)
  const [tableList, setTableList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const formRef = useRef()
  const searchList = [
    {
      type: 'input',
      label: 'languageObj.emailNfcUIDSentFailureReport.exceptionType',
      key: 'exceptionType',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.emailNfcUIDSentFailureReport.exceptionCode',
      key: 'exceptionCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.emailNfcUIDSentFailureReport.productCode',
      key: 'productCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.emailNfcUIDSentFailureReport.sendToAntDate',
      key: 'sendToAntDate',
      format: dateFormat,
      // disabledDate: current => {
      //   let falg = current && current > moment().endOf('day')
      //   return falg
      // },
      initialValues: [startMonth, endMonth],
      spans: { xl: 8, xxl: 8 },
      isdefaultfilter: 'true'
    }
  ]
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.emailNfcUIDSentFailureReport.exceptionType'),
      dataIndex: 'exceptionType',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcUIDSentFailureReport.exceptionCode'),
      dataIndex: 'exceptionCode',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcUIDSentFailureReport.productCode'),
      dataIndex: 'productCode',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcUIDSentFailureReport.quantity'),
      dataIndex: 'quantity',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    }
  ]

  // useEffect(() => {
  //   searchDataFun()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { exceptionCode, exceptionType, productCode, sendToAntDate } = info
    const params = {
      chinese: languageState === 'zh_CN' ? true : false,
      exceptionCode,
      exceptionType,
      productCode,
      sendAntDateStart: formatStartTime(sendToAntDate),
      sendAntDateEnd: formatEndTime(sendToAntDate)
    }
    return params
  }

  const searchDataFun = () => {
    const params = getParams()
    uidSendFailurePage(params).then(res => {
      const dt = res.resultData
      setTableList(dt)
    })
  }

  const searchDataBtn = () => {
    searchDataFun()
  }

  const searchClearDataBtn = () => {
    searchDataFun()
  }

  const downLoadFun = () => {
    const params = getParams()
    uidSendFailureDownload(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const reSendFun = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { sendToAntDate } = info
    const sendAntDateStart = formatStartTime(sendToAntDate)
    const sendAntDateEnd = formatEndTime(sendToAntDate)
    const exceptionCodes = []
    const productCodes = []
    selectedRowKeys.forEach(item => {
      const [exceptionCode, productCode] = item.split('/')
      if (!exceptionCodes.includes(exceptionCode)) exceptionCodes.push(exceptionCode)
      if (!productCodes.includes(productCode)) productCodes.push(productCode)
    })
    const params = {
      exceptionCodes,
      productCodes,
      sendAntDateStart,
      sendAntDateEnd
    }
    console.log('params', params)
    uidSendFailureResend(params).then(res => {
      if (res.errorCode === '200') {
        messageModal('success', {
          content: formatMessageNew('languageObj.commonLocale.success')
        })
        setSelectedRowKeys([])
      } else if (res.errorCode === '951') {
        const data = res.resultData
        const keys = Object.keys(data)
        const str = keys.map(key => {
          return `${data[key]}/${key}`
        })
        modalError({
          content: (
            <div>
              {formatMessageNew('languageObj.commonLocale.products')}&nbsp;{str.join('、')}&nbsp;
              {formatMessageNew('languageObj.commonLocale.resendFailed')}
            </div>
          )
        })
      }
    })
  }

  const onSelectChange = selectedRowKeys => {
    setSelectedRowKeys(selectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            layout={{ labelCol: { span: 10 }, wrapperCol: { span: 14 } }}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container">
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end', marginTop: 15 }}>
            {hasPermission(menu_email_nfc_uid_send_failure_report) && (
              <Button type="primary" className="mr20" disabled={selectedRowKeys.length <= 0} onClick={reSendFun}>
                {formatMessageNew('languageObj.commonLocale.resend')}
              </Button>
            )}
          </ActionBar>
          {/* <div className="opt_btn mt15 mb15" style={{ display: 'flex' }}>
            {hasPermission(menu_email_nfc_uid_send_failure_report) && (
              <Button type="primary" className="mr20" disabled={selectedRowKeys.length <= 0} onClick={reSendFun}>
                {formatMessageNew('languageObj.commonLocale.resend')}
              </Button>
            )}
            <Button onClick={downLoadFun} type="primary" className="ml20">
              {formatMessageNew('languageObj.commonLocale.download')}
            </Button>
          </div> */}
          <AntdTable
            rowKey={record => `${record.exceptionCode}/${record.productCode}`}
            rowSelection={rowSelection}
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的表示，不能重复
            columnsKey="nfcUidSentFailureReportColumns"
          />
        </div>
      </Card>
    </div>
  )
}
export default NFCUIDSentFailureReport
